/**
 * RESPONSIBILITY: the House of Honor band on the home page.
 *
 * ITS WORDS, AND THE APPEAL'S PICTURE UNLESS TOLD OTHERWISE. A teaser says something
 * shorter than the page it teases, so the words here are its own. The photograph is a
 * photograph OF the appeal, which already keeps one — asking for it outright got the
 * identical rendering uploaded twice under two ids, two files to keep in step and no way
 * to tell which was the picture of the building. So this band borrows it, and the field
 * below is there for the band that genuinely wants a different one.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import type { ImageValue } from '@framework/core';
import { Section, Text, Paragraph, Img, Link, RenderOf } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT } from '../hints';

@Section({ name: SectionName.HomeGive, label: 'Home · House of Honor' })
export class HomeGiveSection {
  @Text({
    label: 'Subtitle', maxLength: 120, default: 'Give',
    description: 'The small line above the title.',
  })
  eyebrow!: string;

  @Text({ label: 'Title', maxLength: 300, default: 'House of Honor' })
  heading!: string;

  @Paragraph({ label: 'Description', maxLength: 4000, rows: 4, markdown: true, allow: ['verse'] })
  body!: string;

  @RenderOf('body')
  bodyHtml!: string;

  /** Empty means "use the appeal's own picture" — see the House of Honor section. */
  @Img({
    label: 'A different picture for this band', folder: 'home', maxSizeMb: 12,
    size: '1200 × 900', group: 'Picture', collapsed: true,
    description: 'Leave empty and this band shows the House of Honor picture.',
  })
  image!: ImageValue;

  @Text({ label: 'Button text', maxLength: 120, default: 'Learn more' })
  ctaLabel!: string;
  @Link({ label: 'Button link', description: LINK_HINT })
  ctaHref!: string;
}
